import { createContext } from "react";

import type { IAdminProfile } from "@/api/admin/types";

export interface IAdminAuthContext {
  isLoading: boolean;
  admin: IAdminProfile | null;
  signOut: () => Promise<void>;
  getAdmin: () => void;
}

export const AdminAuthContext = createContext<IAdminAuthContext | undefined>(
  undefined,
);
